export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8288.b6839514.jpg";